const _ = require('lib/underscore')
const BaseElement = require('./element.base')

const ButtonsetElement = BaseElement.extend({

    validateConstructor(attrs) {
        if (! attrs.buttons) throw new Error('Buttonset Element requires a list of buttons.')

        // inline require to allow circular dependency between Element & ElementList
        const ElementList = require('./element_list')

        // ensure that `buttons` is an ElementList
        if (_.isArray(attrs.buttons)) {
            attrs.buttons = new ElementList(attrs.buttons)
        }
        if (! (attrs.buttons instanceof ElementList)) {
            throw new Error('Buttonset Element requires a list of buttons.')
        }
        return attrs
    },

})

module.exports = ButtonsetElement
